import { useMemo } from 'react';
import { Goal, GoalEventType } from 'modules/goals/types';
import { useQueryCampaignMetrics } from './useQueryCampaignMetrics';
import { CampaignForMetric } from './useQueryCampaignsForMetrics';
import type { TopCampaign } from './useQueryGoalTopCampaign';
import { getTopCampaignsBySystemEventGoal } from '../utils/getTopCampaignsBySystemEventGoal';

export type TopCampaignsBySystemEventGoalState = {
  [goalId: string]: TopCampaign;
};

export const useTopCampaignsBySystemEventGoal = (
  startTime: string,
  endTime: string,
  campaigns: CampaignForMetric[],
  goals: Goal[],
) => {
  const campaignIds = useMemo(() => campaigns.map((campaign) => campaign.campaignId), [campaigns]);
  const goalsWithSystemEvents = useMemo(
    () => goals?.filter((goal) => goal.eventType === GoalEventType.System),
    [goals],
  );
  const mediumMetrics = useMemo(
    () =>
      goalsWithSystemEvents
        ?.map((goal) => ({ name: goal?.metricDefinition?.enumName }))
        .filter((mediumMetric) => !!mediumMetric?.name),
    [goalsWithSystemEvents],
  );

  const { goalMetrics } = useQueryCampaignMetrics(
    {
      startTime,
      endTime,
      campaignIds,
      metrics: {
        mediumMetrics,
        overallMetrics: [],
      },
    },
    {
      enabled: !!campaignIds.length && !!mediumMetrics.length,
    },
  );

  const topCampaignsBySystemEventGoal = getTopCampaignsBySystemEventGoal(
    goals,
    goalMetrics,
    campaigns,
  );

  return { topCampaignsBySystemEventGoal };
};
